import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { DispatchBoardService } from '../../../shared/services/dispatch-board.service';
import { DispatchesService } from '../../../shared/services/dispatches.service';
import { DispatchBoardSearch } from '../../../shared/models/DispatchBoardSearch';
import { GlobalsService } from '../../../shared/services/globals.service';
import { BaseMessageInfo } from '../../../shared/models/BaseMessageInfo';
import { DispatchAssignmentBus } from '@app/cp/shared/models/DispatchAssignmentBus';
import * as _ from 'lodash';
import { CommonValues } from '@app/cp/shared/static/CommonValues';
import { NotificationSettings } from '@progress/kendo-angular-notification';

@Component({
    selector: 'cp-delete-assignment',
    templateUrl: './delete-assignment.component.html',
    styleUrls: ['./delete-assignment.component.scss'],
    standalone: false
})
export class DeleteAssignmentComponent implements OnInit {

    constructor(private svc_globals: GlobalsService, private svc_data: DispatchBoardService, private svc_dispatches: DispatchesService) { }
    @Output() titleChild = new EventEmitter<string>();
    @Output() cancel = new EventEmitter();

    @Input() data: any;
    @Input() assignmentData: any;

    selectedStatus: any;
    assignementChangeReturn: BaseMessageInfo;
    canDelete: boolean = false;
    assignments: [DispatchAssignmentBus];
    assignmentToRemove: DispatchAssignmentBus;

    ngOnInit() {
        this.titleChild.emit('Delete Assignment');

        this.svc_dispatches.GetDispatchAssignments(this.assignmentData.assignDispatch.dispatchId).subscribe(data => {
            this.assignments = _.cloneDeep(data);

            if (this.assignmentData.data.personId) { this.assignmentToRemove = this.assignments.filter(assignment => (assignment.assignedPersonId == this.assignmentData.data.personId && assignment.assignedStatusId == CommonValues.DispatchAssignment_Assigned))[0]; }
            else {
                this.assignmentToRemove = this.assignments.filter(assignment => (assignment.dispatchAssignmentId == this.assignmentData.data.dispatchAssignmentId && assignment.assignedStatusId == CommonValues.DispatchAssignment_Assigned))[0];
            }

            //this.assignmentToRemove = this.assignments.filter(assignment => (assignment.assignedPersonId == this.assignmentData.data.personId && assignment.assignedStatusId == CommonValues.DispatchAssignment_Assigned))[0];
            if (this.assignmentToRemove != null) {
                this.canDelete = true;
            }

            if (data.error) {
                console.log('can not find assignments for dispatch' + this.assignmentData.assignDispatch.dispatchId + '!');
            }
        });
        //this.svc_data.
    }

    valueChange(e) {
        this.selectedStatus = e;
    }

    deleteClick() {
        //alert(this.statusData.moveDispatch.dispatchId + ' going to: ' + this.selectedStatus.statusId);
        this.canDelete = false;
        this.svc_data.setNetworkFunction(true);
        this.svc_dispatches.deleteDispatchAssignment(this.assignmentToRemove.dispatchAssignmentId).subscribe(data => {
            this.assignementChangeReturn = data;
            this.svc_data.setNetworkFunction(false);
            this.svc_data.manRefresh();

            if (data.saveError) {
                //alert('something went wrong');
                this.notify('An error occured when deleting the assignment.', "E");
                this.canDelete = false;
            } else {
                this.cancel.emit(null);
                let successMsg = this.assignmentData.data.fullName + " has been successfully removed from Dispatch : " + this.assignmentData.assignDispatch.dispatchNumber;
                this.notify(successMsg, "S");
            }
        });
    }
    cancelClick() {
        this.cancel.emit(null);
    }
    notify(notification: string, type: string = "E", closable: boolean = false, settings: NotificationSettings = { content: '', hideAfter: 2000 }) {
        this.svc_globals.notify(notification, type, closable, settings);
    }

}